import { render } from "./tasks-left.vue?vue&type=template&id=5bd64ea2"
import script from "./tasks-left.vue?vue&type=script&lang=js"
export * from "./tasks-left.vue?vue&type=script&lang=js"

import "./tasks-left.vue?vue&type=style&index=0&id=5bd64ea2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__